import { Card, Col, Row, Skeleton } from "antd"

const PageSkeleton = ({ cards = 4, rows = 8 }) => {
  return (
    <div className="page-skeleton sips">
      {cards > 0 ? (
        <Row gutter={[16, 16]} className="mb-3">
          {Array.from({ length: cards }).map((_, index) => (
            <Col xs={12} md={6} key={index}>
              <Card>
                <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 1 }} />
              </Card>
            </Col>
          ))}
        </Row>
      ) : null}
      <Card>
        <Skeleton active paragraph={{ rows }} />
      </Card>
    </div>
  )
}

export default PageSkeleton
